export const areMenusExclusive = () => window.innerWidth < 800;
